import { render, staticRenderFns } from "./ModalSelectReviewForSimulation.vue?vue&type=template&id=22a2b866&scoped=true&"
import script from "./ModalSelectReviewForSimulation.vue?vue&type=script&lang=js&"
export * from "./ModalSelectReviewForSimulation.vue?vue&type=script&lang=js&"
import style0 from "./ModalSelectReviewForSimulation.vue?vue&type=style&index=0&id=22a2b866&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a2b866",
  null
  
)

component.options.__file = "ModalSelectReviewForSimulation.vue"
export default component.exports